<template>
  <div v-if="authenticated">
    <v-app-bar color="grey darken-3" elevation="24">
      <div class="d-flex align-items-center">
        <v-toolbar-title>
          <router-link
            :to="{ name: 'Home' }"
            class="nav-link active"
            @click.native="loadReminders()"
          >
            <img
              src="/img/propuesta-1-x2.svg"
              :height="isMobile ? '40px' : '45px'"
              alt=""
            />
          </router-link>
        </v-toolbar-title>
        <div class="mx-1 mx-md-2 vertical-divider" />
        <v-img
          src="@/assets/img/logos/service-desk.svg"
          alt="Servicio Post Venta"
          :width="isMobile ? '80px' : '110px'"
          contain
        />
      </div>

      <v-spacer />

      <span class="d-none d-md-block text-white font-weight-bold mr-3"
        >{{ currentDate }} {{ clock }}</span
      >
      <span class="d-none d-md-block text-white mr-md-4">{{ user.name }}</span>

      <div class="d-flex align-center" :class="isMobile ? 'gap-2' : 'gap-3'">
        <notifications />
        <reminder-step-launcher v-if="Policies.BackorderPolicy.canList()" />
        <recent-orders-step-launcher v-if="Policies.OrderPolicy.canList()" />
        <menu-print />
        <v-btn
          icon
          color="grey darken-3"
          small
          @click.prevent="$router.push({ name: 'Logout' })"
        >
          <v-img
            width="25px"
            height="25px"
            contain
            src="@/assets/img/navbar_icons/logout-icon.svg"
          />
        </v-btn>
      </div>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list nav dense>
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <template v-for="(item, index) in menu">
            <router-link
              v-if="
                $hasAnyRole(item.roles) || $hasAnyPermission(item.permissions)
              "
              :key="`menu-${index}-${item.routeName}`"
              :to="{
                name: item.routeName,
                params: { doctype: item.param, idq: item.idq },
              }"
              :class="item.class"
            >
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item>
            </router-link>
          </template>
          <!-- <v-list-item
            @click.prevent="showLoginDialog"
            v-if="$hasAnyRole(['Manager', 'Seller']) || $hasAnyPermission([])"
          >
            <v-list-item-icon>
              <v-img src="/img/logo_iusa.png"></v-img>
            </v-list-item-icon>
            <v-list-item-title>Ir a VEL</v-list-item-title>
          </v-list-item> -->
          <v-list-item @click.prevent="signOut">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Cerrar sesión</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-dialog v-model="loginVelDialog.show" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Iniciar sesión en Vendedor en línea
        </v-card-title>

        <v-card-text>
          <v-row class="mt-4">
            <v-col cols="12">
              <v-text-field
                v-model="loginVelDialog.password"
                outlined
                dense
                label="Contraseña VEL"
                type="password"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn @click="cancelLoginVel"> Cancelar </v-btn>
          <v-btn color="primary" @click="loginVel"> Entrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import { mapGetters, mapActions } from 'vuex';
  import Policies from '@/core/policies';

  import moment from 'moment';
  import screen from '@/mixins/screen';
  import global from '@/mixins/global';

  import MenuPrint from './MenuPrint.vue';
  import Notifications from './Notifications.vue';
  import ReminderStepLauncher from './stepsAfterLogin/ReminderStepLauncher.vue';
  import RecentOrdersStepLauncher from './stepsAfterLogin/RecentOrdersStepLauncher.vue';

  const permissionsOrder = [
    'order.show',
    'order.create',
    'order.update',
    'order.delete',
  ];

  export default {
    components: {
      Notifications,
      MenuPrint,
      ReminderStepLauncher,
      RecentOrdersStepLauncher,
    },
    mixins: [global, screen],
    props: {
      visible: { default: false },
      onlyNav: { default: false },
    },
    data: () => ({
      Policies,
      clock: '',
      velUrl: process.env.VUE_APP_URL_PORTAL_VENDEDOR,
      drawer: false,
      group: null,
      messages: null,
      permissionsOrder: permissionsOrder,
      currentDate: null,
      dialogLoading: false,
      buttonDowloandView: 'Descargar Vista',
      cartItems: null,
      months: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
      menu: [
        {
          routeName: 'Home',
          class: 'nav-link',
          text: 'Inicio',
          icon: 'mdi-home',
          roles: [
            'Administrator',
            //"Customer",
            'Guest',
            // "Manager",
            'Reports',
            //"CustomerPR",
          ],
          permissions: [],
        },
        {
          routeName: 'Administrator',
          class: 'nav-link',
          text: 'Administrador',
          icon: 'mdi-home',
          roles: ['Administrator'],
          permissions: [],
        },
        {
          routeName: 'EmployeesView',
          class: 'nav-link',
          text: 'Empleados',
          icon: 'mdi-account-multiple',
          roles: ['Administrator'],
          permissions: [],
        },
        {
          routeName: 'ProfileUser',
          class: 'nav-link',
          text: 'Cuenta',
          icon: 'mdi-account',
          roles: [
            'Administrator',
            //"Customer",
            'Guest',
            // "Manager",
            'Reports',
            //"CustomerPR",
          ],
          permissions: [],
        },
        {
          routeName: 'ReportStock',
          class: 'nav-link',
          text: 'Reporte Existencias',
          icon: 'mdi-text-box-outline',
          roles: [''],
          permissions: [],
        },
        {
          routeName: 'CustomerRegistration',
          class: 'nav-link',
          text: 'Solicitud Alta Cliente',
          icon: 'mdi-bookmark-check',
          roles: [
            'Guest',
            //  "Manager"
          ],
          permissions: [],
        },
        {
          routeName: 'ShoppingCart',
          class: 'nav-link',
          text: 'Pedido Normal',
          icon: 'mdi-cart',
          roles: [
            // "Customer",
            // "Manager"
          ],
          permissions: permissionsOrder,
        },
        /* {
        routeName: "ShoppingCart",
        class: "nav-link",
        text: "Pedido",
        icon: "mdi-cart",
        param: "PSDT",
        idq:0,
        roles: [
          "Customer",
          // "Manager"
        ],
        permissions: permissionsOrder,
      },*/
        {
          routeName: 'ShoppingCartPop',
          class: 'nav-link',
          text: 'Pedido POP',
          icon: 'mdi-cart',
          roles: [
            //"Customer",
            // "Manager"
          ],
          permissions: permissionsOrder,
        },
        {
          routeName: 'ShoppingCartPdr',
          class: 'nav-link',
          text: 'Pedido de Reorden',
          icon: 'mdi-cart',
          roles: [
            //"Customer",
            // "Manager"
          ],
          permissions: permissionsOrder,
        },
        /*{
        routeName: "ShoppingCartPsma",
        class: "nav-link",
        text: "Pedido Apoyo a Marca",
        icon: "mdi-cart",
        roles: [
          "Customer",
          // "Manager"
        ],
        permissions: permissionsOrder,
      },*/
        {
          routeName: 'ShoppingCartPsnw',
          class: 'nav-link',
          text: 'Pedido Nuevos Productos',
          icon: 'mdi-cart',
          roles: [
            'Customer',
            // "Manager"
          ],
          permissions: permissionsOrder,
        },

        /* {
        routeName: "ShoppingCartPstn",
        class: "nav-link",
        text: "Pedido Tienda Nueva",
        icon: "mdi-cart",
        roles: [
          "Customer",
          // "Manager"
        ],
        permissions: permissionsOrder,
      },*/
        {
          routeName: 'ShoppingCartPR',
          class: 'nav-link',
          text: 'Pedido PR',
          icon: 'mdi-cart',
          roles: [''],
          permissions: permissionsOrder,
        },
        {
          routeName: 'ShoppingCartPopPr',
          class: 'nav-link',
          text: 'Pedido POP',
          icon: 'mdi-cart',
          roles: [
            //"CustomerPR",
            // "Manager"
          ],
          permissions: permissionsOrder,
        },
        {
          routeName: 'ShoppingCartPdrPr',
          class: 'nav-link',
          text: 'Pedido de Reorden',
          icon: 'mdi-cart',
          roles: [
            //"CustomerPR",
            // "Manager"
          ],
          permissions: permissionsOrder,
        },
        /*{
        routeName: "ShoppingCartPsmaPr",
        class: "nav-link",
        text: "Pedido Apoyo a Marca",
        icon: "mdi-cart",
        roles: [
          "CustomerPR",
          // "Manager"
        ],
        permissions: permissionsOrder,
      },*/
        {
          routeName: 'ShoppingCartPsnwPr',
          class: 'nav-link',
          text: 'Pedido Nuevos Productos',
          icon: 'mdi-cart',
          roles: [
            //"CustomerPR",
            // "Manager"
          ],
          permissions: permissionsOrder,
        },
        {
          routeName: 'upload-file',
          class: 'nav-link',
          text: 'Pedido CSV',
          icon: 'mdi-file',
          roles: [
            //"Customer",
            // "Manager"
          ],
          permissions: [],
        },
        {
          routeName: 'QuoterHistory',
          class: 'nav-link',
          text: 'Cotizador',
          icon: 'mdi-cart-arrow-down',
          roles: [''],
          permissions: [],
        },
        {
          routeName: 'HistoryOrders',
          class: 'nav-link',
          text: 'Historial de Pedidos',
          icon: 'mdi-cart',
          roles: [
            //"Customer",
            //"CustomerP",
            // "Manager"
          ],
          permissions: [],
        },
        {
          routeName: null,
          class: 'nav-link',
          text: 'Promociones y descuentos',
          icon: 'mdi-star',
          roles: [
            'Guest',
            //"CustomerPR"
          ],
          permissions: [],
        },
        {
          routeName: 'Manager',
          class: 'nav-link',
          text: 'Solicitudes Alta',
          icon: 'mdi-account-box-outline',
          roles: ['Guest', 'Manager', 'Reports'],
          permissions: [],
        },
        {
          routeName: 'Planeador',
          class: 'nav-link',
          text: 'Planeador',
          icon: 'mdi-calendar',
          roles: ['Manager', 'Seller'],
          permissions: [],
        },
        {
          routeName: 'MultimediaCenter',
          class: 'nav-link',
          text: 'Lista de Precios Vigentes',
          icon: 'mdi-format-list-bulleted-square',
          roles: [
            //"Customer",
            'Guest',
            'Manager',
            'Seller',
            'Reports',
            //"CustomerPR",
          ],
          permissions: [],
        },
        {
          routeName: 'PromissoryNotes',
          class: 'nav-link',
          text: 'Solicitudes Pagaré',
          icon: 'mdi-account-box-outline',
          roles: ['Manager'],
          permissions: [],
        },
        // { routeName: null, class: 'nav-link', text: 'Productos', icon: 'mdi-tag-multiple', roles: ["Administrator", 'Customer', 'Guest'] },
        // { routeName: null, class: 'nav-link', text: 'Familias', icon: 'mdi-card-bulleted-outline', roles: ["Administrator", 'Customer'] },
        {
          routeName: null,
          class: 'nav-link',
          text: 'Oportunidad de Mercado',
          icon: 'mdi-chart-areaspline',
          roles: [''],
          permissions: [],
        },
        {
          routeName: null,
          class: 'nav-link',
          text: 'Movimientos Cuenta',
          icon: 'mdi-arrow-collapse-down',
          roles: [''],
          permissions: [],
        },
        {
          routeName: null,
          class: 'nav-link',
          text: 'Tienda de Éxito',
          icon: 'mdi-storefront-outline',
          roles: [],
          permissions: [],
        },
        {
          routeName: 'MultimediaCenterVideo',
          class: 'nav-link',
          text: 'Multimedia Center',
          icon: 'mdi-folder-multiple-image',
          roles: [
            //"Customer",
            'Guest',
            'Manager',
            'Seller',
            'Reports',
            //"CustomerPR",
          ],
          permissions: [],
        },
        {
          routeName: 'ContactList',
          class: 'nav-link',
          text: 'Contacto',
          icon: 'mdi-account',
          roles: [''],
          permissions: [],
        },
        {
          routeName: 'CustomerAccountStatement',
          class: 'nav-link',
          text: 'Estados',
          icon: 'mdi-account-multiple',
          roles: [''],
          permissions: [],
        },
      ],
      customerBreadcrumb: [
        {
          text: 'Carátula IEL',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Vendedores',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Sureste',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Zona (12730)',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Jesús Gutierrez Perez (2535171)',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
      ],
      loginVelDialog: {
        show: false,
        password: null,
      },
      customer_code: null,
    }),
    computed: {
      ...mapGetters({
        authenticated: 'auth/authenticated',
        user: 'auth/user',
        cartIte: 'ordercart/cart',
        rolesReminders: 'reminders/roles',
      }),
      isCustomer() {
        return this.$route.meta.role == 'Customer' ? true : false;
      },
    },
    async mounted() {
      this.currentDate = moment().format('D [de] MMMM [del] YYYY');
      setInterval(() => (this.clock = moment().format('h:mm a')), 1000);

      this.cartItems = this.cartIte.length;
      //this.customer_code = this.user.custumer_code;
    },
    methods: {
      ...mapActions({
        signInVel: 'auth/sigInVel',
      }),
      ...mapActions('reminders', ['loadReminders']),
      goTo(routeName) {
        this.$router.push({ name: routeName });
      },
      showLoginDialog() {
        this.signInVel(this.loginVelDialog.password).then((data) => {
          this.cancelLoginVel();
          if (data.user == 2) {
            window.open(
              `${this.velUrl}/validate?token=${data.token}`,
              '_blank'
            );
          } else {
            this.$toast.warning('Los datos no son correctos.');
          }
        });
      },
      loginVel() {
        this.signInVel(this.loginVelDialog.password).then((data) => {
          this.cancelLoginVel();
          if (data.user == 2) {
            window.open(
              `${this.velUrl}/validate?token=${data.token}`,
              '_blank'
            );
          } else {
            this.$toast.warning('Los datos no son correctos.');
          }
        });
      },
      cancelLoginVel() {
        this.loginVelDialog.password = null;
        this.loginVelDialog.show = false;
      },
    },
  };
</script>
<style>
  .vertical-divider {
    height: 40px;
    width: 2px;
    background-color: white;
  }
  /* .grey.darken-3 {
  background-color: #2b2b2b !important;
  border-color: #2b2b2b !important;
}
.v-menu__content {
  overflow-y: inherit !important;
  overflow-x: inherit !important;
  contain: inherit !important;
  min-width: auto !important;
} */

  /* @media (max-width: 1263px) {
  .v-menu__content {
    width: auto;
    left: 0 !important;
    right: 0 !important;
    margin: 0 auto;
    position: absolute !important;
  }
} */
</style>
